var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"relative",style:(_vm.containerStyle)},[(_vm.video)?_c('Borderless',{attrs:{"video":_vm.video}}):_vm._e(),(_vm.$storyblok.isEditing)?_c('div',{staticClass:"absolute inset-0 z-50"}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }